module.exports = __webpack_public_path__ + "static/media/dtmf-hash.4fdf289f.mp3";